const translations = {
  en: {
    EMAIL_ALREADY_REGISTERED: 'Email already registered, try with another one.',
    ERROR_GENERATING_PAYMENT_REFERENCE: 'There was a problem generating payment reference, please try later.',
    ERROR_GENERATING_REFERENCE: 'There was a problem generating payment reference, please try later.',
    ERROR_CREATING_OR_GETTING_RECORD: 'There was a problem getting or crerating a record, please try later.'
  },
  es: {
    WRONG_PASSWORD: 'Usuario o contraseña invalida',
    USER_NOT_REGISTERED: 'Usuario no registrado',
    USER_NOT_ACTIVE: 'Usuario deshabilitado, contacta a tu administrador',
    EMAIL_ALREADY_REGISTERED: 'El correo ya se encuentra registrado',
    USER_CREATED_AND_NOTIFIED_BY_EMAIL: 'Nuevo usuario guardado con éxito y ha sido notificado por correo electrónico',
    CANT_SENT_EMAIL: 'No se puede notificar por correo',
    CANT_CREATE_USER: 'No se puede crear el usuario, contacta al administrador con clave #USR-1',
    AT_LEAST_ONE_ADMIN_IS_REQUIRED: 'Al menos un usuario debe ser administrador',
    ERROR_GETTING_USER: 'Contacta al administrador con clave #USR-2',
    USER_UPDATED: '¡Tus datos han sido guardados!',
    CANT_UPDATE_USER: 'No se puede actualizar el usuario, contacta al administrador con clave #USR-3',
    SAVE_FIRST: 'Primero guarda el usuario que tienes pendiente',
    PASSWORD_UPDATED: 'Contraseña actualizada',
    RECOVER_PASS_SUCCESS: 'Se ha enviado un correo electrónico para recuperar la contraseña.',
    RECOVER_PASS_ERROR: 'Hubo un error al hacer la solicitud, contacta al administrador con clave #USR-4',
    INVALID_KEY: 'El token de recuperación de contraseña ha expirado',
    ERROR_GENERATING_PAYMENT_REFERENCE: 'Ha ocurrido un error al generar la referencia, por favor intenta mas tarde.',
    ERROR_GENERATING_REFERENCE: 'Ha ocurrido un error al generar la referencia, por favor intenta mas tarde.',
    ERROR_CREATING_OR_GETTING_RECORD: 'Ha ocurrido un error al obtener o crear un registro, por favor intenta mas tarde.',
    CANT_FIND_CLIENT: 'Cliente no encontrado',
    INVALID_EMAIL: 'Email invalido'
  }
}

export default translations
